module.exports = __webpack_public_path__ + "img/SCB_WebLogo.95e749f7.png";